'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _auditprogress = require('./auditprogress.component');

var _auditprogress2 = _interopRequireDefault(_auditprogress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var auditprogressModule = _angular2.default.module('auditprogress', [_angularUiRouter2.default]).component('auditprogress', _auditprogress2.default);

exports.default = auditprogressModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/auditprogress/auditprogress.js